/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ServiceObjectPartnerCreateV1Dto = {
  /**
   * ID of the partner associated with the service object
   */
  partnerId: string;
  /**
   * Role of the partner associated with the service object, can be either Landlord, Maintenance or Partner
   */
  role: ServiceObjectPartnerCreateV1Dto.role;
};
export namespace ServiceObjectPartnerCreateV1Dto {
  /**
   * Role of the partner associated with the service object, can be either Landlord, Maintenance or Partner
   */
  export enum role {
    LANDLORD = 'Landlord',
    MAINTENANCE = 'Maintenance',
    PARTNER = 'Partner',
  }
}
